import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.img`
  ${({theme}) => css`
    width: 16px;
    height: 16px;
    border-radius: 50%; 
    margin-left: 4px;
    border: 1px solid ${theme?.colour?.primary};
  `}
`

export default Atom({ type: 'image', datatype: 'string', template })